class ProductPersonalization extends HTMLElement {
  connectedCallback() {
    this.form = this.closest('form');
    this.input = this.querySelector('input[name="properties[Numele copilului]"]');
    this.personalizedVariantIds = new Set(
      (this.dataset.personalizedVariantIds || '')
        .split('|')
        .map((id) => id.trim())
        .filter(Boolean)
    );

    this.handleVariantUpdate = (event) => {
      if (String(event.detail?.data?.productId) !== String(this.dataset.productId)) return;
      this.update(event.detail?.resource?.id);
    };

    document.addEventListener('variant:update', this.handleVariantUpdate);
    this.update(this.form?.querySelector('input[name="id"]')?.value);
  }

  disconnectedCallback() {
    document.removeEventListener('variant:update', this.handleVariantUpdate);
  }

  update(variantId) {
    const isPersonalized = this.personalizedVariantIds.has(String(variantId || ''));

    this.hidden = !isPersonalized;
    if (!this.input) return;

    this.input.disabled = !isPersonalized;
    this.input.required = isPersonalized;
    this.input.setAttribute('aria-required', String(isPersonalized));
  }
}

if (!customElements.get('product-personalization')) {
  customElements.define('product-personalization', ProductPersonalization);
}
